import React from 'react'
import Activities from './Activities'

const ActivitiesWrapper = () => {
  return (
    <Activities/>
  )
}

export default ActivitiesWrapper